var _defs, _g, _path, _g2, _path2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiCrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crane1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.532,
    height: 115,
    viewBox: "0 0 82.532 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-awdawdawd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 82.532,
    height: 115,
    fill: "none",
    stroke: "#b9b1b4",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    clipPath: "url(#clip-path-awdawdawd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M40.62,114.33,22.58,72.022,40.9.5l38.16,65.034L74.034,110.64l-18.125-3.393ZM22.949,70.579.5,13.669l26.171,42.38ZM69.854,49.848l11.9-43.728L76.708,61.528Z",
    transform: "translate(0.138 0.085)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M49.8,85.806l-32-24.2,8.533,20.01Z",
    transform: "translate(4.922 10.501)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    clipPath: "url(#clip-path-awdawdawd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M32.146.5,45.829,96.221l1.326,11.025",
    transform: "translate(8.891 0.085)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M33.988,101,24.48,78.7l23.47,4.19,1.326,11.025Z",
    transform: "translate(6.771 13.415)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M42.865,86.751,67.341,56.063,64.986,77.207Zm19.451,14.418,2.669-23.962L42.865,86.751,44.19,97.776Z",
    transform: "translate(11.856 9.556)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    clipPath: "url(#clip-path-awdawdawd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M17.8,72.021,36.115.5,49.8,96.222Z",
    transform: "translate(4.922 0.085)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiCrown);
export default __webpack_public_path__ + "static/media/origami-crown.56d81ad0bafd5ecb1fee7a8a5d3331ce.svg";
export { ForwardRef as ReactComponent };